// extracted by mini-css-extract-plugin
export default {"pickerList":"VoicePicker_pickerList__tEYJ+","pickerContainer":"VoicePicker_pickerContainer__xZ2IT","dropdown-selector":"VoicePicker_dropdown-selector__8IP2K"};